import VuexPersistence from 'vuex-persist';
import dbStorage from './db';
import reducer from './reducer';
import { saveHandler, restoreHandler } from './handler';
import mutationFilter from './mutationFilter';


export default function(store, modules, onSaved = null) {
    // Store modules with data which should be stored in the localStorage
    const localModules = {
        $root: {},
        user: modules.user,
        navigation: modules.navigation,
        alerts: modules.alerts,
        validation: modules.validation 
    };
    let localTrigger = null;

    const vuexLocal = new VuexPersistence({
        key: 'smartdoors',
        storage: window.localStorage,
        saveState: (key, data, storage) => {
            saveHandler(data, storage, key, true);
            
            if(onSaved) {
                onSaved(localTrigger);
            }
        },
        restoreState: (key, storage) => {
            return JSON.parse(restoreHandler(storage, key));
        },
        reducer: state => { 
            return reducer(store, 'local', state, localModules, true); 
        },
        filter: mutation => {
            const result = mutationFilter(mutation, localModules);

            if(result) {
                localTrigger = result;
                return true;
            }

            return false;
        }
    });
    
    // Store modules with data which should be stored in the indexedDB
    const dbModules = {
        user: modules.user, 
        tasks: modules.tasks,
        jobs: modules.jobs
    };
    let dbTrigger = null;
    
    const vuexDb = new VuexPersistence({
        storage: dbStorage,
        asyncStorage: true,
        saveState: async (key, data, storage) => {
            await storage.ready;
            await saveHandler(data, storage, null, false, true);
            
            if(onSaved) {
                onSaved(dbTrigger);
            }
        },
        restoreState: async (key, storage) => {
            await storage.ready;
            return restoreHandler(storage, null, dbModules, true);
        },
        reducer: state => { 
            return reducer(store, 'db', state, dbModules, false, dbTrigger);
        },
        filter: mutation => {
            const result = mutationFilter(mutation, dbModules);

            if(result) {
                dbTrigger = result;
                return true;
            }

            return false;
        }
    });
    
    // Attach persistence plugins to the store
    vuexLocal.plugin(store);
    vuexDb.plugin(store);
}